import {
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { BLUEMONEDDBUTTONS, GRAY, WHITE } from "../../../../constants/colors";
import { useSetRecoilState } from "recoil";
import { refreshGlobal } from "../../../../atoms/refreshGlobal";
import SuportSolicitationsAPI from "../../../../services/servicosSolicitacoesApi";
import { suporteListAndamentoInterface } from "../../../../interfaces/defaultInterfaces";
import { dateForListWithHours } from "../../../../constants/dataFormat";
import moment from "moment";
import { useRecoilState } from "recoil";

const ModalVisualizacao = ({ isOpen, setIsOpen, id }: any) => {
  const finalRef = React.useRef(null);
  const navigate = useNavigate();
  const refresh = useRecoilState(refreshGlobal)[0];

  const [suporteSelecionado, setSuporteSelecionado] = useState(
    Array<suporteListAndamentoInterface>
  );

  async function getSuport() {
    try {
      const response = await SuportSolicitationsAPI.getSuporteAndamento(id);
      setSuporteSelecionado(response);
      console.log("response do suporte", response);
    } catch (error) {
      console.log("error: ", error);
    }
  }
  useEffect(() => {
    if(id !== 0) {
      getSuport();
    }
  }, [id, refresh]);

  const setRefreshGlobal = useSetRecoilState(refreshGlobal);

  const onClose = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Modal
        finalFocusRef={finalRef}
        isOpen={isOpen}
        onClose={onClose}
        size={"4xl"}
      >
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent>
          <ModalHeader>Andamento da Solicitação</ModalHeader>
          <ModalBody>
            <TableContainer my={3}>
              <Table variant="striped" colorScheme="blue" size="md">
                <Thead>
                  <Tr>
                    {/* <Th bgColor={VARIANT} color={WHITE}>
                Data
              </Th> */}
                    <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                      Data
                    </Th>
                    <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                      Resposável
                    </Th>
                    <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                      Status
                    </Th>
                    <Th bgColor={BLUEMONEDDBUTTONS} color={WHITE}>
                      Descrição
                    </Th>
                  </Tr>
                </Thead>
                <Tbody>
                  {suporteSelecionado &&
                    suporteSelecionado.map((item: any, index: number) => {
                      return (
                        <Tr key={index}>
                          <Td>
                            {moment(item.data).format(dateForListWithHours)}
                          </Td>
                          <Td>{item.responsavel.nome}</Td>
                          <Td>{item.servicoStatus.situacao}</Td>
                          <Td>{item.descricao ? item.descricao : ""}</Td>
                        </Tr>
                      );
                    })}
                </Tbody>
              </Table>
            </TableContainer>
          </ModalBody>
          <ModalFooter justifyContent={"space-evenly"}>
            <Button
              background={GRAY}
              color={WHITE}
              mr={3}
              onClick={() => {
                onClose();
              }}
            >
              Fechar
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalVisualizacao;
